
import {
  defineComponent,
  ref,
  computed,
  PropType,
  watch,
} from 'vue';

import { useCreatedDevAccount } from '../composables/index';

import { IAccountInfoParams } from '@/api/manage-app/account-info/index.d';

export default defineComponent({
  name: 'CreatedDevAccount',
  emits: ['update:visible', 'handleSearch'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    accountItem: {
      type: Object as PropType<IAccountInfoParams>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const selfVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });
    const formData = ref<IAccountInfoParams>({
      accountId: '', // 开发者账号id
      accountName: '', // 开发者账号名称
      holder: '', // 持有人
      accountEmail: '', // 开发者账号邮箱
      openingTime: '', // 开通时间
      overdueTime: '', // 到期时间
    });

    const {
      handleSave,
      handleClose,
    } = useCreatedDevAccount(
      formData,
      emit as any,
    );

    watch(props, (val) => {
      if (val.visible && props.accountItem.id) {
        formData.value = props.accountItem;
      } else {
        formData.value = Object.assign({}, {
          accountId: '', // 开发者账号id
          accountName: '', // 开发者账号名称
          holder: '',
          accountEmail: '', // 开发者账号邮箱
          openingTime: '', // 开通时间
          overdueTime: '', // 到期时间
        });
      }
    });

    return {
      formData,
      selfVisible,
      rules: {
        accountId: [
          { required: true, message: '请输入开发者账号id', trigger: 'blur' },
        ],
        accountName: [
          { required: true, message: '请输入开发者账号名称', trigger: 'blur' },
        ],
        holder: [
          { required: true, message: '请输入持有人', trigger: 'blur' },
        ],
        accountEmail: [
          { required: true, message: '请输入开发者账号邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
        ],
        openingTime: [
          { required: true, message: '请选择开通时间', trigger: 'change' },
        ],
        overdueTime: [
          { required: true, message: '请输入到期时间', trigger: 'change' },
        ],
      },
      // pickerEndTime: {
      //   disabledDate(time: Date) {
      //     return time.getTime() < new Date(formData.value.openingTime).getTime();
      //   },
      // },
      // pickerStartTime: {
      //   disabledDate(time: Date) {
      //     return time.getTime() < new Date().getTime();
      //   },
      // },
      handleSave,
      handleClose,
    };
  },
});
